export default __webpack_public_path__ + "static/media/map_extended.1328388f.png";